import { Observable } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { COMMON_WEB_URL } from '../variables';
import { ImageSyncResults } from '../model/imageSyncModel';

@Injectable({
  providedIn: 'root'
})
export class ImageSyncApiService {
  private http: HttpClient;
  private baseUrl: string;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(COMMON_WEB_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : "https://localhost";
  }

  /**
   * @return response
   */
  public syncImages(accountKey: string, email: string): Observable<ImageSyncResults> {
    const url = this.baseUrl + `/api/transfer-images?accountKey=${accountKey}&email=${email}`;

    this.http.get(url, { withCredentials: true, headers: { accountKey: accountKey }}).subscribe();

    return new Observable<ImageSyncResults>();
  }
}
